"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var mini_svg_data_uri_1 = __importDefault(require("mini-svg-data-uri"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var WILSON = mini_svg_data_uri_1.default("<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0 41.5903C3.80677 39.1686 8.5063 37.3269 13.7524 36.2881C10.2368 33.3531 8.0001 28.9378 8.0001 24C8.0001 15.1634 15.1635 8 24.0001 8C32.8367 8 40.0001 15.1634 40.0001 24C40.0001 28.9993 37.7073 33.4631 34.1158 36.3971C39.4549 37.5179 44.2073 39.4743 48 42.0263V48H0V41.5903Z\" fill=\"#91D8EC\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.8799 24.5916L18.1305 25.5315C18.4897 26.8785 20.1701 29.6733 24 29.6733C27.8299 29.6733 29.5103 26.8785 29.8695 25.5315L30.1201 24.5916L32 25.0929L31.7494 26.0328C31.2438 27.9285 28.9899 31.6188 24 31.6188C19.0101 31.6188 16.7562 27.9285 16.2506 26.0328L16 25.0929L17.8799 24.5916Z\" fill=\"#2727E6\"/>\n<path d=\"M21.7302 19.6213C21.7302 20.5167 21.0043 21.2426 20.1089 21.2426C19.2135 21.2426 18.4876 20.5167 18.4876 19.6213C18.4876 18.7259 19.2135 18 20.1089 18C21.0043 18 21.7302 18.7259 21.7302 19.6213Z\" fill=\"#2727E6\"/>\n<path d=\"M29.5124 19.6213C29.5124 20.5167 28.7865 21.2426 27.8911 21.2426C26.9957 21.2426 26.2698 20.5167 26.2698 19.6213C26.2698 18.7259 26.9957 18 27.8911 18C28.7865 18 29.5124 18.7259 29.5124 19.6213Z\" fill=\"#2727E6\"/>\n</svg>");
exports.Wrapper = styled_components_1.default.img.attrs(function (_a) {
    var src = _a.src;
    return ({
        src: src || WILSON,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  object-fit: cover;\n  background-color: ", ";\n\n  @media ", " {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  @media ", " {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n"], ["\n  display: block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  object-fit: cover;\n  background-color: ", ";\n\n  @media ", " {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  @media ", " {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n"])), function (_a) {
    var $size = _a.$size;
    return $size.small;
}, function (_a) {
    var $size = _a.$size;
    return $size.small;
}, function (_a) {
    var $size = _a.$size;
    return $size.small;
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return theme_1.theme.colors[$backgroundColor || 'WHITE'];
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $size = _a.$size;
    return $size.medium;
}, function (_a) {
    var $size = _a.$size;
    return $size.medium;
}, function (_a) {
    var $size = _a.$size;
    return $size.medium;
}, theme_1.theme.breakpoints.large, function (_a) {
    var $size = _a.$size;
    return $size.large;
}, function (_a) {
    var $size = _a.$size;
    return $size.large;
}, function (_a) {
    var $size = _a.$size;
    return $size.large;
});
var templateObject_1;
